<div #mainDiv_ll_exam_sections_sp>

  <canvas #vertTab_ll_exam_sections_sp></canvas>

  <!--scrollpane_ll_exam_sections_sp-->
  <div *ngIf="bundle.showObj">

    <div class="spLabel" [ngStyle]="{'top.px':bundle.lblY, 'width.px':bundle.spW}">
      {{bundle.lable}}
    </div>

    <jqxPanel #scrollpane_ll_exam_sections_sp
              [style.top.px]="bundle.spY"
              style="background-color: transparent;
              border: none;
              outline: none;
              border-bottom: 1px solid  rgb(160, 158, 158);"
              [autoUpdate]="true"
              [rtl]="true"
              [width]="bundle.spW"
              [height]="bundle.spH">

      <tr *ngFor="let item of bundle.records" style="white-space: nowrap;">



        <div class="spRowLabel"
             [id]="bundle.prefix + item.FOLDERID"
             title={{item.FOLDERNAME}}
             [style.width.px]="bundle.spW - 20" (click)="select($event)">
          {{item.FOLDERNAME}}
        </div>

      </tr>



    </jqxPanel>

  </div>


  <div *ngIf="bundle.showRemaining">

    <div [style.top.px]="bundle.remainingY"
         [style.left.px]="bundle.remainingX"
         [style.width.px]="bundle.remainingW"
         [style.height.px]="bundle.remainingH"
         style="position: absolute; ">

      <ll-exam-sections-scope *ngIf="this.bundle.selectedId === 1 "></ll-exam-sections-scope>
      <ll-exam-sections-locations *ngIf="this.bundle.selectedId === 2 "></ll-exam-sections-locations>
      <ll-exam-sections-receivables *ngIf="this.bundle.selectedId === 4 "></ll-exam-sections-receivables>
    </div>

  </div>
</div>
